export default "__VITE_ASSET__Bea1NRmU__"